import request from './api'

export class CompetitionService {
    async getCompetitions() {
        const response = await request({
            method: 'GET',
            url: `api/competitions/list`
        });

        return response;
    }

    static get instance() { return competitionService }
}

const competitionService = new CompetitionService();

export default competitionService;